import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { PAYMENT_COUPON_TYPE, PROMO_CODE_STATUS, STRATEGY } from "app/constants";
import { bindActionCreators } from "redux";
import { initialize, reset } from "redux-form";
import PromotionCode from "app/pages/Booking/PromotionCode/PromotionCode";
import { sendTagOnVoucherCodeSubmission } from "app/utils/analytics";
import {
	clearPromotionValue,
	sendPromotionCode,
} from "app/pages/Booking/PromotionCode/promotionCodeActionCreators";
import { logout } from "app/pages/Auth/AuthActions";
import { withRouter } from "react-router-dom";

const PromotionCodeContainer = props => {
	const {
		sendPromotionCode,
		quotationCode,
		logout,
		history,
		strategy,
		reset,
		status,
		message,
		onValidPromoCodeApplied,
		onFocus,
		couponType,
		clearPromotionValue,
	} = props;

	useEffect(() => {
		if (
			couponType === PAYMENT_COUPON_TYPE.CREDIT &&
			status === PROMO_CODE_STATUS.INVALID_PROMOCODE
		) {
			clearPromotionValue();
			reset("promotion-code-form"); // si invalid promo code, alors le code promo n'est pas enregistré dans le store
		}
	}, [couponType]);

	const sendCodePromo = useCallback(codePromo => {
		if (
			status === PROMO_CODE_STATUS.SUCCESS ||
			status === PROMO_CODE_STATUS.INVALID_PROMOCODE
		) {
			delete codePromo.promoCode;
			reset("promotion-code-form");
		}

		sendTagOnVoucherCodeSubmission();

		codePromo.code = quotationCode;
		sendPromotionCode(codePromo).then(res => {
			if (res.status === 200) {
				if (
					((res.data.status === PROMO_CODE_STATUS.SUCCESS && codePromo.promoCode) ||
						res.data.status === PROMO_CODE_STATUS.REMOVED_PROMOCODE) &&
					typeof onValidPromoCodeApplied === "function"
				) {
					onValidPromoCodeApplied(codePromo.promoCode);
				}
			} else if (res.status === 403) {
				logout();
				history.replace({ pathname: "/home/login" });

				if (strategy !== STRATEGY.OAUTH) {
					history.push("/home/login");
				} else {
					history.push("/technical-error/sso");
				}
			}
		});
	});

	return (
		<PromotionCode
			message={message}
			status={status}
			onSubmit={sendCodePromo}
			onFocus={onFocus}
			{...props}
		/>
	);
};

PromotionCodeContainer.propTypes = {
	// soumettre ou pas le formulaire. Si false, cela permet d'utiliser ce composant en tant que children d'un form
	submit: PropTypes.bool,
	initializeForm: PropTypes.func,
	status: PropTypes.string,
	message: PropTypes.string,
	formInitialValues: PropTypes.object,
	sendPromotionCode: PropTypes.func,
	logout: PropTypes.func,
	reset: PropTypes.func,
	history: PropTypes.shape({ push: PropTypes.func, replace: PropTypes.func }),
	quotationCode: PropTypes.string,
	strategy: PropTypes.string,
	showAmountInButton: PropTypes.bool,
	onValidPromoCodeApplied: PropTypes.func,
	onFocus: PropTypes.func,
	clearPromotionValue: PropTypes.func,
	couponType: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		quotationCode: state.quotation.code,
		disabled: state.booking.credits > 0,
		status: state.promotion.status,
		message: state.promotion.message,
		promotionValue: state.promotion.promotionValue,
		promotionCode: state.promotion.promotionCode,
		strategy: state.partner.strategy,
		formInitialValues: {
			promoCode: state.promotion.promotionCode || "",
		},
		couponType: state.booking.coupon,
	};
};

const mapDispatchToProps = dispatch => {
	return Object.assign(
		{},
		{
			initializeForm: initializeValues => {
				dispatch(initialize("promotion-code-form", initializeValues));
			},
		},
		bindActionCreators(
			{
				sendPromotionCode,
				clearPromotionValue,
				reset,
				logout,
			},
			dispatch
		)
	);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PromotionCodeContainer)
);
